/**
 * This file is auto-generated by protobufgen
 * Don't change manually
 */



export enum ErrCode {
	ErrCodeOK = "ErrCodeOK",
	ErrCodeNotFound = "ErrCodeNotFound",
	ErrCodeUnkown = "ErrCodeUnkown",
	ErrCodeGetFailed = "ErrCodeGetFailed",
	ErrCodeUnLogin = "ErrCodeUnLogin",
	ErrCodeNonsupport = "ErrCodeNonsupport",
	ErrCodeInvalidTime = "ErrCodeInvalidTime",
}


export enum ModuleInteraction {
	None = "None",
	RollOver = "RollOver",
	SingleSliding = "SingleSliding",
	Zoom = "Zoom",
	ZoomSliding = "ZoomSliding",
}



export interface Result {
	/**
	 * @minimum 0
	 * @TJS-type integer
	 */
	code?: number;
	msg?: string;
}